import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mx-auto min-h-screen max-w-md px-4 py-16" }

import { IonContent, IonPage } from '@ionic/vue';
import { useCart } from '@/stores/cart';
import { onMounted } from 'vue';
import { useNavigation } from '@/stores/navigation';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

const cart = useCart();
const navigation = useNavigation();

onMounted(() => {
  if (cart.order && cart.order.status !== 'Paid') {
    navigation.goTo('payment', true, cart.params);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})